import React, { Component } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from '../../util/withRouter';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import moment from 'moment';
import Cookies from 'universal-cookie';
import _ from 'lodash';

import NextSync from '../NextSync';
import { User } from '../User/User';
import Subscribe from '../Subscribe/Subscribe';
import { hasManageBilling } from '../../util/roles';
import { windowLocation } from '../../util/url';
import windowSize from '../../util/windowSize';
import { toggleNavigationShown } from '../../modules/App/AppActions';
import { joinAccount } from '../../modules/Auth/AuthActions';
import { getNotifications } from '../../modules/Notifications/NotificationsActions';

import { translate } from '../../util/translate';

import houseIcon from '../../assets/img/house-icon.svg';

// Import Images
import logo from '../../assets/img/nave-logo.svg';

import './Header.scss';

class Header extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);

    this.state = {
      bannerUpdate: false
    };

    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateNoticesHeight();
    if (
      !this.props.wallmode &&
      !this.props.notificationsLoading &&
      !this.props.notificationsLoaded &&
      this.props.user &&
      this.props.user._id &&
      this.props.user._id !== 'temp'
    ) {
      this.props.getNotifications();
    }
  }

  componentDidUpdate() {
    this.updateNoticesHeight();
    if (
      !this.props.wallmode &&
      !this.props.notificationsLoading &&
      !this.props.notificationsLoaded &&
      this.props.user &&
      this.props.user._id &&
      this.props.user._id !== 'temp'
    ) {
      this.props.getNotifications();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this.noticesObserver) {
      this.noticesObserver.disconnect();
    }
    document.documentElement.style.removeProperty('--notices-height');
  }

  toggleMenu() {
    this.props.toggleNavigationShown(!this.props.navigationShown);
  }

  onRequest = acc => {
    this.props.joinAccount(acc.accountId, acc.iid);
  };

  onHandleStalledWebhooks = () => {
    if (this.props.user && this.props.user.host) {
      if (this.props.outside) { 
        // TODO: implement oauth1 token authentication flow in plugin
      } else {
        const cookies = new Cookies();
        cookies.set('backTo', windowLocation().pathname + windowLocation().search, {
          path: '/',
          maxAge: 60
        });
        windowLocation().replace(`/api/integrations/login${!!this.props.location.search ? this.props.location.search + '&' : '?'}h=${this.props.user.host}&cleanup=true`);
      }
    }
  }

  closeBanner = (id, enabledOn) => {
    localStorage.setItem(`notification-${id}-${enabledOn}`, false);
    this._isMounted && this.setState({ bannerUpdate: !this.state.bannerUpdate });
  };

  renderBanner = () => {
    const { user, wallmode, notifications } = this.props;

    if (
      wallmode ||
      !user ||
      !user._id ||
      user._id === 'temp' ||
      !notifications ||
      !notifications.list ||
      !notifications.list.length
    ) {
      return;
    }

    const isAnnual = user.isAnnual && user.status === 'active';
    const isMonthly = !user.isAnnual && user.status === 'active';
    const isTrial = user.status === 'trial' && moment(user.trialEnd).isSameOrAfter(moment());
    const hasBillingAccess = user.permissions.manageBilling;
    const isEnrolled = notifications.enrolledSp;
    const isActualPlan = user.plan && user.plan.indexOf('-plan') > -1;

    const list = _(notifications.list)
      .filter(n => {
        const userStartDate = user.activatedAt ? user.activatedAt : user.createdAt;

        const startTime = moment(userStartDate).add(n.start_day, 'days');
        const endTime = moment(userStartDate).add(n.end_day, 'days');

        const isWithinTimeFrame = moment().isBetween(startTime, endTime);

        const isRollingPeriodActivated = isWithinTimeFrame && n.timeline.activated && user.activated;

        const isRollingPeriodTrial = isWithinTimeFrame && isTrial && n.timeline.trial;

        const show = !n.audience || (
          (n.audience[1] === true && hasBillingAccess) ||
          (n.audience[2] === true && isMonthly) ||
          (n.audience[3] === true && isAnnual) ||
          (n.audience[4] === true && isTrial) ||
          (n.audience[5] === true && isEnrolled) ||
          (n.audience[6] === true && isActualPlan)
        );

        const hide =
          n.audience &&
          ((n.audience[1] === false && hasBillingAccess) ||
            (n.audience[2] === false && isMonthly) ||
            (n.audience[3] === false && isAnnual) ||
            (n.audience[4] === false && isTrial) ||
            (n.audience[5] === false && isEnrolled) ||
            (n.audience[6] === false && isActualPlan));

        return (n.rolling_period && (isRollingPeriodActivated || isRollingPeriodTrial)) || (n.fixed_period && show && !hide);
      })
      .filter(n => {
        return !localStorage.getItem(`notification-${n._id}-${n.enabledOn}`);
      })
      .value();

    if (list.length) {
      const formatted = list[0].description
        .replace(/rel=\"noopener noreferrer\"/gm, 'rel="noopener noreferrer" target="_blank" class="notification_action"')
        .replace(/<p>/gm, '<span>')
        .replace(/<\/p>/gm, '</span>');

      const sanitized = DOMPurify.sanitize(formatted, { FORCE_BODY: true, ADD_ATTR: ['target'] });

      return this.renderNotice(
        'static',
        'info',
        <span className='announcement_text' dangerouslySetInnerHTML={{ __html: sanitized }}></span>,
        () => this.closeBanner(list[0]._id, list[0].enabledOn)
      );
    }
  };

  renderNotice(key, type, content, onClose) {
    const toneClass = { info: ' notification', warning: ' warning', problem: '' }[type];

    return (
      <div key={key} className={`notification_bar${toneClass}`}>
        <div className='container'>
          <svg className='notification_icon' width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {type === 'warning' ? (
              <React.Fragment>
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                <path d="M12 9v4" />
                <path d="M12 17h.01" />
              </React.Fragment>
            ) : (
              <React.Fragment>
                <circle cx="12" cy="12" r="10" />
                <path d={type === 'info' ? 'M12 16v-4' : 'M12 8v4'} />
                <path d={type === 'info' ? 'M12 8h.01' : 'M12 16h.01'} />
              </React.Fragment>
            )}
          </svg>
          <div className='notification_text'>{content}</div>
          {onClose && (
            <Button className='btn-close' onClick={onClose}>
              &times;
            </Button>
          )}
        </div>
      </div>
    );
  }

  render() {
    const {
      hideUser,
      showHome,
      showReport,
      showTeam,
      router,
      showSync,
      user,
      dashboardSelector,
      buttons,
      title,
      dashboard,
      dashboards,
      issue,
      wallmode,
      outside,
      stayHere
    } = this.props;

    const failedJob = (dashboard && dashboardSelector && _.first(dashboard.failedJobs)) || {};

    let failedJobMessage;
    if (issue) {
      if (router.location && router.location.pathname && router.location.pathname.startsWith('/update/')) {
        if (typeof issue === 'string') {
          failedJobMessage = issue;
        } else if (issue.data && issue.data.board && issue.data.board.msg) {
          failedJobMessage = translate(issue.data.board.msg);
        }
      }
    }
    if (failedJob.type) {
      failedJobMessage = translate(failedJob.type);
      if (
        ['not-authenticated', 'user-not-found', 'no-access', 'no-default-project', 'cf-endpoint-error'].indexOf(
          failedJob.type
        ) > -1
      ) {
        failedJobMessage = failedJobMessage.replace('{DASHBOARD_ID}', dashboard._id);
      }
    }
        const noUserMessage = dashboard && dashboard._id && (
      dashboard.updatedBy === 'no_user' || 
      (dashboard.updatedBy === null && dashboard.createdBy === 'no_user')
    );
    const accessRequests = user && user.accessRequests && router.location && router.location.pathname !== '/users';

    const relatedAccount = user.relatedAccounts && user.relatedAccounts[0];

    const hasStalledWebhooks = user && user.config && user.config.hasStalledWebhooks;

    const shouldUpdateDashboard = router && router.location && router.location.query && router.location.query.updateDashboard === 'true';
    
    const items = [
      this.renderBanner(),
      // this.state.showBanner && (
      //   <div key={'static'} className='notification_bar notification'>
      //     <div className='container'>
      //       {user && user.isAnnual ? (
      //         <span>
      //           Black Friday Offer 🎁 Until Nov 30th, all licenses for the Sustainable Predictability program will be
      //           30% OFF! Use the code <b>NAVEBLACK22</b> at the checkout to apply your discount →{' '}
      //           <a className="white" target="_blank" href="https://getnave.com/enroll">
      //             https://getnave.com/enroll
      //           </a>
      //         </span>
      //       ) : (
      //         <span>
      //           Black Friday Offer 🎁 Until Nov 30th, all annual plans at Nave, as well as all licenses for the
      //           Sustainable Predictability program will be 30% OFF! Use the code <b>NAVEBLACK22</b> at the checkout to
      //           apply your discount →{' '}
      //           <a className="white" target="_blank" href="https://getnave.com/black">
      //             https://getnave.com/black
      //           </a>
      //         </span>
      //       )}
      //       <Button className='btn-close' onClick={this.closeBanner}>
      //         &times;
      //       </Button>
      //     </div>
      //   </div>
      // ),
      // this.state.showBanner && (
      //   <div key={'static'} className='notification_bar notification'>
      //     <div className='container'>
      //       <span>
      //         [Live Q&A with Sonya] Mar 7th, 3pm UTC! Join us on Zoom for one hour of Interactive Q&A goodness!{' '}
      //         <a className="white" target="_blank" href="https://www.addevent.com/event/cd16077255&utm_source=app&utm_medium=notification-message&utm_campaign=march-live-q&a">
      //           Add this event to your calendar →
      //         </a>
      //       </span>
      //       <Button className='btn-close' onClick={this.closeBanner}>
      //         &times;
      //       </Button>
      //     </div>
      //   </div>
      // ),
      !!accessRequests && !wallmode && this.renderNotice('notice-access', 'info',
        <React.Fragment>
          Someone requested access to your account. <Link className="notification_action" to="/users">Review requests →</Link>
        </React.Fragment>
      ),
      !!relatedAccount && !!relatedAccount.invited && !wallmode && this.renderNotice('notice-invitation', 'info',
        <React.Fragment>
          You've been invited to your organization's Nave account. <Link className="notification_action" onClick={() => this.onRequest(relatedAccount)}>Join account →</Link>
        </React.Fragment>
      ),
      !!failedJobMessage && !wallmode && this.renderNotice('notice-sync', 'problem',
        <span dangerouslySetInnerHTML={{ __html: failedJobMessage.replace(/\n/g, '<br />') }}></span>
      ),
      !!noUserMessage && !wallmode && !failedJobMessage && this.renderNotice('notice-creator', 'warning',
        <React.Fragment>
          This dashboard will stop receiving the latest data because the person who last updated it no longer exists in Nave. <Link className="notification_action" href={`/api/dashboards/${dashboard._id}/refetch`}>Resync dashboard →</Link>
        </React.Fragment>
      ),
      shouldUpdateDashboard && !wallmode && this.renderNotice('notice-query', 'problem',
        <React.Fragment>
          Your board query has changed. Review the dashboard mapping to keep your data up to date. <Link className="notification_action" to={{ pathname: `/update/${dashboard._id}`, query: { ...router.location.query, updateDashboard: true } }}>Review mapping →</Link>
        </React.Fragment>
      ),
      hasStalledWebhooks && !wallmode && !outside && this.renderNotice('notice-webhooks', 'problem',
        <React.Fragment>
          This dashboard isn't receiving the latest data. <Link className="notification_action" onClick={this.onHandleStalledWebhooks}>Reconnect Jira →</Link>
        </React.Fragment>
      ),
      <div key={6}
        className={`top_header ${!wallmode && hasManageBilling(user) && user.status !== 'active' && 'upgrade'}`} >
        {wallmode && (
          <div className='orange_header_logo'>
           <img src={logo} alt="" />
          </div>
        )}

        {/* Home button */}
        {(user.status && dashboards.length > 0  || showHome !== false) && !wallmode && (
          <div className='left_part'>
            {/*{showHome !== false && !stayHere && (
              <Link
                to={`${dashboard && dashboard._id ? `/dashboard/${dashboard._id}` : '/'}`}
                className='btn btn-sm btn-icon btn-secondary'
              >
                <img src={houseIcon} alt="" />
              </Link>
            )}F
            {showHome !== false && stayHere && (
              <Link                
                className='btn btn-sm btn-icon btn-secondary'
              >
                <img src={houseIcon} alt="" />
              </Link>
            )}
            {showReport && (
              <Link to="/report" className='btn btn-sm btn-outline-primary'>
                Executive Dashboard
              </Link>
            )}
            {showTeam && (
              <Link to="/" className='btn btn-sm btn-outline-primary'>
                Team Dashboards
              </Link>
            )}*/}
            {!!showSync && <NextSync />}
          </div>
        )}

        {/*<div className={`dropdown_position_center ${ notification_selector: false }`}>{dashboardSelector}</div>*/}
        <div className='center_part'>
          <OverlayTrigger placement="bottom" delay={{ show: 250, hide: 2000 }}
            overlay={<Tooltip id="tooltip-mcp-docs" className='tooltip_dark'>Connect Nave to your AI assistant.</Tooltip>}>
          <Link to="/mcp-docs" className="btn btn-mcp" aria-label="MCP docs">
            <div>
              <svg
                className="mcp-slash"
                width="18" height="18" viewBox="0 0 18 18"
                fill="none" xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  pathLength="1"
                  d="M10.539 1L2.17157 9.36743C0.609475 10.9295 0.609475 13.4621 2.17157 15.0243C3.73367 16.5863 6.26632 16.5863 7.82842 15.0243L16.1959 6.65685"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                />
              </svg>

              <svg
                className="mcp-mark"
                width="26" height="29" viewBox="0 0 26 29"
                fill="none" xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  pathLength="1"
                  d="M11.6063 1.46447C13.559 -0.488136 16.7249 -0.48818 18.6775 1.46447C20.6302 3.41709 20.6302 6.58298 18.6775 8.5356L10.1334 17.0797C9.74283 17.4701 9.10945 17.4702 8.71898 17.0797C8.32859 16.6892 8.32864 16.0558 8.71898 15.6653L17.2631 7.12121C18.4347 5.94964 18.4347 4.05041 17.2631 2.87886C16.0916 1.7077 14.1922 1.7074 13.0207 2.87886L1.70726 14.1923C1.31675 14.5828 0.68339 14.5828 0.292875 14.1923C-0.0976371 13.8018 -0.0976129 13.1685 0.292875 12.7779L11.6063 1.46447Z"
                  fill="currentColor"
                />
                <path
                  pathLength="1"
                  d="M17.2631 7.12121C19.2158 5.16863 22.3816 5.16857 24.3343 7.12111L24.3929 7.1797C26.3456 9.13228 26.3463 12.2982 24.3937 14.2508L14.161 24.4828C14.0312 24.6129 14.0309 24.8247 14.161 24.9548L16.2622 27.056C16.6526 27.4465 16.6526 28.0791 16.2622 28.4696C15.8717 28.8601 15.2383 28.8601 14.8478 28.4696L12.7474 26.3683C11.8362 25.4571 11.8362 23.9804 12.7474 23.0692L22.9793 12.8364C24.1508 11.6649 24.1509 9.76563 22.9793 8.59409L22.9207 8.5355L22.8084 8.42889C21.6307 7.36482 19.8125 7.40061 18.6775 8.5356L10.2515 16.9616C9.86094 17.3521 9.2276 17.3521 8.83708 16.9616C8.44655 16.5711 8.44656 15.9377 8.83708 15.5472L17.2631 7.12121Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </Link>
          </OverlayTrigger>

          <React.Fragment>{dashboardSelector}</React.Fragment>
          <div className='title-dashboard'>{title}</div>
        </div>
        
        <div className='right_part'>
          {!hideUser && !wallmode && hasManageBilling(user) && user.status !== 'active' && !showTeam  && <Subscribe />}
          {!hideUser && buttons}
          {!hideUser && !wallmode && user.status && <User />}
        </div>
      </div>
    ];

    return <div className='header_stack' ref={this.observeNotices}>{items}</div>;
  }

  updateNoticesHeight = () => {
    const header = this.stackNode && this.stackNode.querySelector('.top_header');
    document.documentElement.style.setProperty('--notices-height', `${header ? header.offsetTop : 0}px`);
  };

  observeNotices = node => {
    if (this.noticesObserver) {
      this.noticesObserver.disconnect();
    }
    this.stackNode = node;
    if (!node || typeof ResizeObserver === 'undefined') {
      return;
    }
    this.noticesObserver = new ResizeObserver(this.updateNoticesHeight);
    this.noticesObserver.observe(node);
  };
}

Header.propTypes = {
  dashboardSelector: PropTypes.node,
  buttons: PropTypes.node,
  title: PropTypes.node
};

const mapDispatchToProps = dispatch => {
  return {
    joinAccount: (acc, iid) => dispatch(joinAccount(acc, iid)),
    getNotifications: () => dispatch(getNotifications()),
    toggleNavigationShown: show => dispatch(toggleNavigationShown(show))
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
    notifications: state.notifications.notifications,
    notificationsLoading: state.notifications.isLoading,
    notificationsLoaded: state.notifications.isLoaded,
    outside: state.app.outside,
    wallmode: state.app.wallmode,
    navigationShown: state.app.navigationShown,
    user: state.auth.user,
    dashboards: state.dashboards.list,
    issue: state.dashboards.issue,
    dashboard: state.dashboards.selected
  };
}

export default withRouter(windowSize(connect(mapStateToProps, mapDispatchToProps)(Header)));
export { Header };
